import { createAction } from 'Helpers';
import categoryTypes from './types';

const categoryActions = {
	activesRequest: createAction(categoryTypes.ACTIVES.REQUEST),
	activesSuccess: createAction(categoryTypes.ACTIVES.SUCCESS),
	activesFailure: createAction(categoryTypes.ACTIVES.FAILURE),
	activesClear: createAction(categoryTypes.ACTIVES.CLEAR),

	recommendedRequest: createAction(categoryTypes.RECOMMONED.REQUEST),
	recommendedSuccess: createAction(categoryTypes.RECOMMONED.SUCCESS),
	recommendedFailure: createAction(categoryTypes.RECOMMONED.FAILURE),
	recommendedClear: createAction(categoryTypes.RECOMMONED.CLEAR),

	subCategoriesRequest: createAction(categoryTypes.SUB_CATEGORIES.REQUEST),
	subCategoriesSuccess: createAction(categoryTypes.SUB_CATEGORIES.SUCCESS),
	subCategoriesFailure: createAction(categoryTypes.SUB_CATEGORIES.FAILURE),
	subCategoriesClear: createAction(categoryTypes.SUB_CATEGORIES.CLEAR),

	dynamicAttributesRequest: createAction(
		categoryTypes.DYNAMIC_ATTRIBUTES.REQUEST
	),
	dynamicAttributesSuccess: createAction(
		categoryTypes.DYNAMIC_ATTRIBUTES.SUCCESS
	),
	dynamicAttributesFailure: createAction(
		categoryTypes.DYNAMIC_ATTRIBUTES.FAILURE
	),
	dynamicAttributesClear: createAction(categoryTypes.DYNAMIC_ATTRIBUTES.CLEAR),

	tagsRequest: createAction(categoryTypes.TAGS.REQUEST),
	tagsSuccess: createAction(categoryTypes.TAGS.SUCCESS),
	tagsFailure: createAction(categoryTypes.TAGS.FAILURE),
	tagsClear: createAction(categoryTypes.TAGS.CLEAR),
};

export default categoryActions;
